<template>
  <div class="echart" style="width: 100%; height: 100%">
    <div v-if="hasStat" :id="el" style="width: 100%; height: 100%"></div>
    <div v-else style="margin-top: 60px; text-align: center">暂时没有数据</div>
  </div>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'Echart',
  props: {
    el: {
      type: String,
      default: '',
    },
    hasStat: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  activated() {
    this.initChart()
  },
  mounted() {
    if (this.hasStat && this.el) {
      this.initChart()
    }
  },
  methods: {
    initChart() {
      const node = document.getElementById(this.el)
      if (node) {
        const myChart = echarts.init(node)
        myChart.clear()
        myChart.setOption(this.options)
      }
    },
  },
}
</script>
